import httpClient from '@/apis/base/httpclient';
import SystemApi from './_systemApi';

class LayoutApi extends SystemApi {
  controllerName = 'layouts';

  /**
   * Lấy layout đang sử dụng
   */
  getApply(code) {
    let request = {
      url: [this.getAPIUrl(), '/apply/', code].join('')
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy layout mặc định
   */
  getDefault(code) {
    let request = {
      url: [this.getAPIUrl(), '/default/', code].join('')
    };

    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật layout mới
   * @param {string} metaData
   * @returns Promise
   */
  update(metaData, code) {
    const request = {
      url: [this.getAPIUrl(), '/', code].join(''),
      data: metaData
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy nhiều
   * @param {*} codes mảng các tags
   * @returns Promise
   */
  getMultiple(codes) {
    let request = {
      url: [this.getAPIUrl(), '/multiple/'].join(''),
      data: codes
    };
    return httpClient.postAsync(request);
  }

  /**
   * Update nhiều
   */
  updateMultiple(metaData) {
    const request = {
      url: [this.getAPIUrl(), '/multiple/'].join(''),
      data: metaData
    };
    return httpClient.putAsync(request);
  }
}

export default new LayoutApi();
